module.exports = __webpack_public_path__ + "media/images/athletes/1904-b4182178e3e8feee038fee8f5684f49d.png";